export default __webpack_public_path__ + "media/images/sunflower-bg-0e8b1cf0649af91cd80fc9e6e3bfa8eb.png";